"use client";

import { TooltipProvider } from "@/components/atoms/Tooltip/BaseTooltip";
import { SentryUserTracker } from "@/components/monitor/SentryUserTracker";
import { BackendAPIProvider } from "@/lib/autogpt-server-api/context";
import { getQueryClient } from "@/lib/react-query/queryClient";
import CredentialsProvider from "@/providers/agent-credentials/credentials-provider";
import OnboardingProvider from "@/providers/onboarding/onboarding-provider";
import { PostHogPageViewTracker, PostHogProvider, PostHogUserTracker } from "@/providers/posthog/posthog-provider";
import { LaunchDarklyProvider } from "@/services/feature-flags/feature-flag-provider";
import { QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider, ThemeProviderProps } from "next-themes";
import { NuqsAdapter } from "nuqs/adapters/next/app";
import { Suspense } from "react";
export function Providers({
  children,
  ...props
}: ThemeProviderProps) {
  const queryClient = getQueryClient();
  return <QueryClientProvider client={queryClient} data-sentry-element="QueryClientProvider" data-sentry-component="Providers" data-sentry-source-file="providers.tsx">
      <NuqsAdapter data-sentry-element="NuqsAdapter" data-sentry-source-file="providers.tsx">
        <PostHogProvider data-sentry-element="PostHogProvider" data-sentry-source-file="providers.tsx">
          <BackendAPIProvider data-sentry-element="BackendAPIProvider" data-sentry-source-file="providers.tsx">
            <SentryUserTracker data-sentry-element="SentryUserTracker" data-sentry-source-file="providers.tsx" />
            <PostHogUserTracker data-sentry-element="PostHogUserTracker" data-sentry-source-file="providers.tsx" />
            <Suspense fallback={null} data-sentry-element="Suspense" data-sentry-source-file="providers.tsx">
              <PostHogPageViewTracker data-sentry-element="PostHogPageViewTracker" data-sentry-source-file="providers.tsx" />
            </Suspense>
            <CredentialsProvider data-sentry-element="CredentialsProvider" data-sentry-source-file="providers.tsx">
              <LaunchDarklyProvider data-sentry-element="LaunchDarklyProvider" data-sentry-source-file="providers.tsx">
                <OnboardingProvider data-sentry-element="OnboardingProvider" data-sentry-source-file="providers.tsx">
                  <ThemeProvider forcedTheme="light" {...props} data-sentry-element="ThemeProvider" data-sentry-source-file="providers.tsx">
                    <TooltipProvider data-sentry-element="TooltipProvider" data-sentry-source-file="providers.tsx">{children}</TooltipProvider>
                  </ThemeProvider>
                </OnboardingProvider>
              </LaunchDarklyProvider>
            </CredentialsProvider>
          </BackendAPIProvider>
        </PostHogProvider>
      </NuqsAdapter>
    </QueryClientProvider>;
}